import { sync } from 'vuex-router-sync';
import notifications from './notifications';
import vueMeta from './meta';
import store from './store';
import router from './router';
import i18n from './i18n';

sync(store, router, notifications);

export {
  store,
  vueMeta,
  router,
  i18n,
  notifications,
};



// WEBPACK FOOTER //
// ./src/config.js